<div *ngIf="file" [class]="'document-item document-item--' + status">
  <slm-svg-icon
    class="document-item__icon"
    [icon]="typeIcon"
    [color]="iconColor"
  ></slm-svg-icon>
  <div class="document-item__content flex">
    <div class="w-100">
      <h5 class="document-item__content__name">{{ name || file?.name }}</h5>
      <ng-container [ngSwitch]="status">
        <mat-progress-bar
          *ngSwitchCase="'uploading'"
          class="document-item__content__progress"
          mode="determinate"
          color="accent"
          [value]="progress"
        ></mat-progress-bar>
        <span
          *ngSwitchCase="'done'"
          class="document-item__content__message"
        >{{
            'LBL_UPLOAD_FILL.UPLOAD_DIALOG.SUCCESS'
              | translate: {size: file?.size || 0 | filesize}
          }}</span
        >
        <span
          *ngSwitchCase="'canceled'"
          class="document-item__content__message"
        >{{ 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.CANCELED' | translate }}</span
        >
        <span
          *ngSwitchCase="'error'"
          class="document-item__content__message"
        >{{ 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.ERROR' | translate }}</span
        >
        <span
          *ngSwitchCase="'timeout'"
          class="document-item__content__message"
        >{{ 'LBL_UPLOAD_FILL.UPLOAD_DIALOG.RETRY_UPLOAD' | translate }}</span
        >
      </ng-container>
    </div>
  </div>
  <div class="document-item__button pt-0 h-auto w-auto">
    <slm-loader *ngIf="ocrStatus === -1; else ocrIcon" [diameter]="22" class="p-0 mt-1_5 mh-auto block"></slm-loader>
    <ng-template
      #ocrIcon
    >
      <slm-svg-icon
        *ngIf="!!ocrColumn"
        [style.fill]="ocrColumn.color"
        [icon]="ocrColumn.icon"
        [matTooltip]="(ocrColumn.label || ocrColumn?.tooltip) | translate"
        class="block mt-1_5 mh-auto"
      ></slm-svg-icon>
    </ng-template>
  </div>

  <slm-button-icon
    *ngIf="!hideClose"
    class="document-item__button fill-accent"
    [elevation]="true"
    [icon]="buttonIcon"
    [matTooltip]="tooltipLabel | translate"
    (click)="buttonClicked()"
  ></slm-button-icon>
  <slm-button-icon *ngIf="status === 'done' && !hideOpen"
                   [icon]="icon.OPEN_IN_NEW"
                   class="size-25 fill-accent ml-2"
                   [elevation]="true"
                   (click)="buttonClicked('open')"
                   [matTooltip]="'LBL_BTN.OPEN' | translate"></slm-button-icon>
</div>
